import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add_col_before",
  "use": "add_col_before-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"add_col_before\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18 18a1 1 0 001-1v-4h4a1 1 0 100-2h-4V7a1 1 0 10-2 0v4h-4a1 1 0 100 2h4v4a1 1 0 001 1zM0 23a1 1 0 001 1h8a1 1 0 001-1V1a1 1 0 00-1-1H1a1 1 0 00-1 1v22zm2-2a1 1 0 001 1h4a1 1 0 001-1V3a1 1 0 00-1-1H3a1 1 0 00-1 1v18z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol